import { Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useMemo, useState } from "react";
import { formatarMonetárioParaNúmero, formatarValorMonetario } from "../../../../../../../../helpers/masks";
import DialogCadastrarValor, { IInternFormCheckout } from "./DialogCadastrarValor";
import { useFormContext } from "react-hook-form";
import { IDataPublicos } from "../../../../../../../../types/api/geral/pesquisar-publicos";

export default function FormasPagamento({
    subTotal,
    cliente
}: FormasPagamentoProps) {

    const { setValue, watch } = useFormContext()
    const valueRecb: IInternFormCheckout[] = watch('valoresAdicionados')

    const [openModal, setOpenModal] = useState<IOpenModal>({
        state: false,
        preValue: null
    })
    //funções manipuladoras
    const handleOpenModal = (value: number | null = null) => {
        setOpenModal({
            state: true,
            preValue: value
        })
    }

    const handleCloseModal = () => {
        setOpenModal({
            state: false,
            preValue: null
        })
    }

    const handleRemoveItem = (index: number) => {
        const valoresRecb = watch('valoresAdicionados')
        valoresRecb.splice(index, 1);
        setValue('valoresAdicionados', valoresRecb)
    }
    //

    //valores importantes
    const valorSubTotal = useMemo(() => valueRecb.reduce((acumulador: number, item: any) =>
        acumulador + formatarMonetárioParaNúmero(item.valor), 0
    ), [valueRecb])

    const totalAcrescimos = useMemo(() => {
        return valueRecb.reduce((acumulador: number, item: any) =>
            acumulador + (item.pagamento.parcelas.length > 0 ? item.pagamento.parcelas.reduce((acumulador: number, item: any) =>
                acumulador + item.valor, 0) : formatarMonetárioParaNúmero(item.valor)), 0
        ) - valorSubTotal
    }, [valueRecb, valorSubTotal])

    const valorRestante = watch("valor_restante")
    const condicaoPagamento = watch("condicao_pagamento")

    const disabledBtn = useMemo(() => {
        if (!condicaoPagamento) return true

        return false
    }, [condicaoPagamento])
    //

    return (
        <Box mt={2}>
            {
                (valueRecb.length <= 0) && (
                    <Box
                        display="flex"
                        alignItems="center"
                        flexDirection="column"
                        justifyContent="center"
                        borderRadius={1}
                        height={200}
                        border="1px dashed #1B5E20"
                        gap={0.5}
                    >
                        <Typography variant="subtitle2">Clique no botão abaixo para adicionar os valores</Typography>
                        <Typography variant="caption" mb={1}>(Ex: Dinheiro, PIX, Cartão de Crédito, etc..)</Typography>
                        <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={() => handleOpenModal()}
                            disabled={disabledBtn || valorRestante <= 0}
                        >
                            Adicionar
                        </Button>
                    </Box>
                )
            }

            {
                (valueRecb.length > 0) &&
                <>
                    <Box mb={1} display="flex" alignItems="center" justifyContent="flex-end">
                        <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={() => handleOpenModal()}
                            disabled={valueRecb.length === 4 || disabledBtn || valorRestante <= 0}
                        >
                            Adicionar
                        </Button>
                    </Box>

                    <TableContainer sx={{ border: "1px solid #ccc", borderRadius: 2 }}>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Tipo</b></TableCell>
                                    <TableCell align="right"><b>Valor</b></TableCell>
                                    <TableCell align="right"><b>Acréscimos</b></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {
                                    valueRecb.map((item, index) => {
                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {item.forma_recebimento?.nome ?? "-"}
                                                </TableCell>

                                                <TableCell align="right">
                                                    {item.valor} {item.pagamento.qtdParcelas > 0 ? `(${item.pagamento.qtdParcelas}x)` : ""}
                                                </TableCell>

                                                <TableCell align="right">
                                                    {
                                                        item.pagamento.parcelas.length > 0 ?
                                                            formatarValorMonetario(item.pagamento.parcelas.reduce((acumulador: number, item: any) =>
                                                                acumulador + item.valor, 0) - formatarMonetárioParaNúmero(item.valor))
                                                            : formatarValorMonetario(0)
                                                    }
                                                </TableCell>

                                                <TableCell align="right">
                                                    <Box display="flex" gap={0.5} justifyContent="flex-end">
                                                        <IconButton aria-label="edit" size="small" onClick={() => handleOpenModal(index)}>
                                                            <EditIcon fontSize="inherit" />
                                                        </IconButton>

                                                        <IconButton aria-label="delete" size="small" color="error" onClick={() => handleRemoveItem(index)}>
                                                            <DeleteIcon fontSize="inherit" />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }

                                <TableRow
                                    sx={{
                                        bgcolor: "#E8E8E8",
                                        '&:last-child td, &:last-child th': { border: 0 }
                                    }}
                                >
                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        <b>Valor total</b>
                                    </TableCell>

                                    <TableCell
                                        align="right"
                                    >
                                        <b>{formatarValorMonetario(valorSubTotal)}</b>
                                    </TableCell>
                                    <TableCell align="right">
                                        <b>{formatarValorMonetario(totalAcrescimos)}</b>
                                    </TableCell>
                                    <TableCell align="right">
                                        <b>{formatarValorMonetario(totalAcrescimos + valorSubTotal)}</b>
                                    </TableCell>
                                </TableRow>
                                <TableRow
                                    sx={{
                                        bgcolor: "#e6cfcf",
                                        '&:last-child td, &:last-child th': { border: 0 }
                                    }}
                                >
                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        <b>Valor restante</b>
                                    </TableCell>

                                    <TableCell
                                        align="right"
                                        colSpan={3}
                                    >
                                        <b>{formatarValorMonetario(valorRestante)}</b>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            }

            {
                openModal.state &&
                <DialogCadastrarValor
                    {...{ subTotal, cliente }}
                    open={openModal.state}
                    value={openModal.preValue}
                    handleClose={() => handleCloseModal()}
                />
            }
        </Box>
    )
}

interface IOpenModal {
    state: boolean,
    preValue: number | null
}

interface FormasPagamentoProps {
    subTotal: number
    cliente: IDataPublicos
}